// Publiczny hook dodania komentarza klienta do POZYCJI oferty -
// POST /sales-crm/public-offers/{token}/positions/{positionId}/comments
// BEZ OAuth (uzywa publicAxios). Po sukcesie unieważnia query szczegolow oferty.

import publicAxios from 'api/publicAxios';
import { useMutation, useQueryClient, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';
import { getPublicOfferQueryKey } from 'api/endpoints/useGetPublicOffer';

export interface IPostPublicOfferPositionCommentPayload {
  comment: string;
}

interface IMutationContext {
  positionId: number;
  payload: IPostPublicOfferPositionCommentPayload;
}

const postPublicOfferPositionComment = (
  token: string,
  positionId: number,
  payload: IPostPublicOfferPositionCommentPayload
): Promise<ICommandResponseSuccess> =>
  publicAxios.post(
    `/sales-crm/public-offers/${token}/positions/${positionId}/comments`,
    payload
  );

export const usePostPublicOfferPositionComment = (
  token: string,
  options?: UseMutationOptions<ICommandResponseSuccess, IError, IMutationContext>
) => {
  const queryClient = useQueryClient();

  return useMutation<ICommandResponseSuccess, IError, IMutationContext>(
    ({ positionId, payload }) => postPublicOfferPositionComment(token, positionId, payload),
    {
      ...options,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(getPublicOfferQueryKey(token));
        options?.onSuccess?.(data, variables, context);
      }
    }
  );
};
